<template>
  <q-page class="row items-center justify-center">
    <div class="q-pa-md">
      <q-img
        src="/images/commingsoon.jpg"
        class="rounded-img"
        :ratio="1"
        width="300px"
        fit="cover"
      />
    </div>
    <!-- <div class="row q-col-gutter-sm justify-center q-gutter-y-xs q-pa-sm">
      <template v-for="(item, index) in parentCategories" :key="index">
        <q-card class="col-6">
          <q-card-section>
            <q-btn
              :label="item.name"
              class="full-width text-body1 text-secondary text-weight-bold"
              style="border: 2px solid var(--q-secondary); border-radius: 10px"
              flat
              @click="handleClick(item)"
            />
            <div class="text-caption text-center ellipsis text-accent q-mt-xs">
              {{ item.product.name }}
            </div>
            <div class="text-dark">
              <div
                v-if="
                  item.product.is_on_sale &&
                  item.product.variants[0]?.sale_price
                "
                class="row items-center justify-center"
              >
                <span class="text-primary text-weight-bold">
                  {{
                    formatCurrency(item.product.variants[0]?.sale_price || 0)
                  }}
                </span>
                <span class="text-caption text-grey-6 text-strike q-ml-xs">
                  {{
                    formatCurrency(item.product.variants[0]?.retail_price || 0)
                  }}
                </span>
              </div>
              <div v-else class="text-caption text-center ellipsis text-accent">
                {{
                  formatCurrency(item.product.variants[0]?.retail_price || 0)
                }}
              </div>
            </div>
          </q-card-section>
        </q-card>
      </template>
    </div>
    <div v-if="parentCategories.length > 0" class="col-12 q-my-sm">
      <separator size="3px" color="grey-4" />
    </div>
    <div v-if="!saleProductScroll.isEmpty.value" class="text-center col">
      <q-infinite-scroll @load="saleProductScroll.onLoad" :offset="250">
        <product
          :products="saleProductScroll.allItems.value"
          @add-to-cart="payload => addToCart(payload.payload, payload.product)"
          @open-quick-view="openQuickView"
          @change-attributes="changeAttributes"
        >
        </product>

        <template #loading>
          <div class="row justify-center q-my-md">
            <q-spinner-dots color="primary" size="40px" />
          </div>
        </template>
      </q-infinite-scroll>
    </div>
    <div
      v-else
      class="text-center text-accent q-pa-md row justify-center items-center"
    >
      No Products Promotions Available
    </div>
    <quick-view-image
      v-model="dialog"
      :images="selectedGallery"
      :videos="selectedVideos"
    /> -->
  </q-page>
</template>

<script setup lang="ts"></script>
